document.addEventListener("DOMContentLoaded", function () {
  const root = document.getElementById("shipping-secure");
  if (!root || typeof Swiper === "undefined") return;

  const swiper = new Swiper(root, {
    slidesPerView: "auto",
    loop: true,
    spaceBetween: 10,
    grabCursor: true,
    initialSlide: 0,
    updateOnWindowResize: true,
    watchOverflow: true,
    centeredSlides: false,
    speed: 8000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
  });
});
